import {SELECT_TAB} from "./TabsActionTypes";
import {TAB_BRIDGE_WIDGET, TAB_INLINE_WIDGET, TAB_MODAL_WIDGET, TAB_UPDATE_PI_WIDGET, TAB_BUTTON_WIDGET} from "./TabsConstants";

const initialState = {
  selected: TAB_MODAL_WIDGET,
  list: [
    {key: TAB_MODAL_WIDGET, value: 'Modal Widget'},
    {key: TAB_INLINE_WIDGET, value: 'Inline Widget'},
    {key: TAB_BRIDGE_WIDGET, value: 'Widget as Bridge'},
    {key: TAB_UPDATE_PI_WIDGET, value: 'Update PI'},
    {key: TAB_BUTTON_WIDGET, value: 'Button Widget'}
  ]
};

export function tabs(state = initialState, action) {
  switch (action.type) {
    case SELECT_TAB:
      if (action.value === state.selected) {
        return state;
      }
      return {
        ...state,
        selected: action.value
      };
    default:
      return state;
  }
};

export const getTabs = state => {
  return state.tabs.list;
};

export const getSelected = state => {
  return state.tabs.selected;
};



// WEBPACK FOOTER //
// ./src/tabs/TabsReducers.js